import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleConsultClick = () => {
    window.open('https://pf.kakao.com/_xnekRX/chat', '_blank', 'noopener,noreferrer');
  };

  const navLinks = [
    { name: '홈', path: '/' },
    { name: '서비스', path: '/services' },
    { name: '포트폴리오', path: '/portfolio' },
    { name: '가격', path: '/pricing' },
    { name: '후기', path: '/reviews' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="https://public.readdy.ai/ai/img_res/e1589dec-861a-445d-ba4d-901f8503ac73.png"
              alt="유흥디자인랩"
              className="h-10 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-all duration-300 hover:text-neon-pink relative group ${
                  location.pathname === link.path
                    ? 'text-neon-pink'
                    : isScrolled
                    ? 'text-gray-700'
                    : 'text-gray-900'
                }`}
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-neon-pink transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}
            <button
              onClick={handleConsultClick}
              className="bg-neon-pink text-white px-6 py-2.5 rounded-full font-bold hover:bg-neon-pink/90 hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
            >
              상담하기
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer hover:bg-gray-100 rounded-lg transition-colors"
          >
            <i
              className={`text-2xl transition-all duration-300 ${
                isMobileMenuOpen ? 'ri-close-line rotate-90' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-500 ${
            isMobileMenuOpen ? 'max-h-96 opacity-100 mt-6' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="flex flex-col gap-4 py-4 bg-white rounded-2xl shadow-lg px-6">
            {navLinks.map((link, index) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium py-2 transition-all duration-300 hover:text-neon-pink hover:translate-x-2 ${
                  location.pathname === link.path ? 'text-neon-pink' : 'text-gray-700'
                }`}
                style={{ transitionDelay: `${index * 50}ms` }}
              >
                {link.name}
              </Link>
            ))}
            <button
              onClick={() => {
                handleConsultClick();
                setIsMobileMenuOpen(false);
              }}
              className="bg-neon-pink text-white px-6 py-2.5 rounded-full font-bold hover:bg-neon-pink/90 transition-all cursor-pointer whitespace-nowrap mt-2"
            >
              상담하기
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
